<!-- 维修工单 -->
<template>
  <div ref="madeForm">
    <avue-form :option="optionForm" ref="form" v-model="formData">
      <template slot="repairAmount">
        <custom-input v-model="formData.repairAmount" maxlength="10" precision="2" placeholder="请输入"></custom-input>
      </template>
    </avue-form>
    <span slot="dialog_footer" class="dialog-footer">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { uploadEndpoint, updateStatus } from "../api";

export default {
  name: "WorkOrderManagement",
  props: {
    currentRow: {}
  },
  mixins: [crudMixins],
  data () {
    return {
      formData: {},
      optionForm: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "处理方式",
            prop: "handlingMethod",
            type: "select",
            dicData: [
              { label: "现场处理", value: "现场处理" },
              { label: "远程处理", value: "远程处理" },
              { label: "电话指导", value: "电话指导" },
              { label: "其他方式", value: "其他方式" },
            ],
            rules: [{ required: true, message: "请输选择" }],
          },
          {
            label: "维修金额",
            prop: "repairAmount",
            search: true,
            span: 12,
            width: 160,

          },
          {
            label: "图片",
            prop: "imagePath",
            type: "upload",
            multiple: true,
            drag: true,
            action: uploadEndpoint,
            propsHttp: { res: "data", url: "link" },
            dataType: "string",
            listType: "picture-card",
            tip: "支持多图上传, 最多可上传5张图片",
            limit: 5,
            slot: true,
            span: 24,
            hide: true
          },
          {
            label: "处理备注",
            prop: "remark",
            type: "textarea",
            span: 24,
            maxlength: 200,
            minRows: 3,
          },
        ],
      },
    };
  },
  mounted () {
    console.log(this.currentRow, 'currentRow');
  },
  methods: {
    statusText (v) {
      const item = this.statusDic().find((i) => i.value === v);
      return (item && item.label) || "-";
    },

    // 提交取消
    submitForm () {
      this.$refs.form.validate((valid, d) => {
        if (valid) {
          this.loading = true
          const { workOrderId, id } = this.currentRow
          updateStatus({ ...this.formData, workOrderId, id, orderStatus: 2 }).then(({ data }) => {
            this.$message.success(data.msg)
            this.$emit('handleClose', true)
          }).finally(() => {
            this.loading = false
            d && d()
          })
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

